import { defineMessages } from 'react-intl';

const messages = defineMessages({
    title: {
        id: 'PasswordReset.title',
        defaultMessage: 'Reset password',
    },
    subtitle: {
        id: 'PasswordReset.subtitle',
        defaultMessage: 'Send confirmation code to:',
    },
    reset: {
        id: 'PasswordReset.reset',
        defaultMessage: 'Request confirmation code',
        description: 'Label for the reset button',
    },
    resetError: {
        id: 'PasswordReset.resetError',
        defaultMessage: 'Error resetting password',
    },
});

export default messages;
